export default {
  methods: {
    getQuestion(question) {
      return {
        ...question,
        otherChiefComplaintId: question?.otherChiefComplaint?.id,
      };
    },
    transformedAllQuestionsList(allQuestionsList) {
      return [...allQuestionsList]?.map(({ otherChiefComplaint, ...rest }) => {
        return {
          otherChiefComplaintTitle: otherChiefComplaint?.title,
          ...rest,
        };
      });
    },
    transformedAllSelectedQuestions(selectedQuestionsList) {
      if (!selectedQuestionsList || !Array.isArray(selectedQuestionsList)) {
        return [];
      }

      return selectedQuestionsList.map(({ id }) => ({
        questionId: id,
      }));
    }
  },
};
